import React from "react";
import AIVietnam from '../../assets/companies/aivietnam.svg';
import FullStackDataScience from '../../assets/companies/fullstackdatascience.svg';
import Huredee from '../../assets/companies/huredee.svg';
import Udemy from '../../assets/companies/udemy.svg';
import Study4 from '../../assets/companies/study4.svg';
import Coursera from '../../assets/companies/coursera.svg';

export default function SliderLearn() {
  const companies = [
    { logo: AIVietnam, name: "AI Vietnam", height: "65px" },
    // { logo: FullStackDataScience, name: "Full Stack Data Science", height: "60px" },
    { logo: Huredee, name: "Huredee", height: "60px" },
    // { logo: Udemy, name: "Udemy", height: "55px" },
    // { logo: Study4, name: "Study4", height: "50px" },
    { logo: Coursera, name: "Coursera", height: "60px" }
  ];

  return (
    <div className="relative px-4 py-20 overflow-hidden bg-black">
      {/* Cyberpunk Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-cyan-400/20 to-blue-600/20 rounded-full blur-3xl animate-pulse-neon"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-br from-pink-400/20 to-purple-600/20 rounded-full blur-3xl animate-pulse-neon delay-1000"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(cyan 1px, transparent 1px),
            linear-gradient(90deg, cyan 1px, transparent 1px)
          `,
          backgroundSize: '100px 100px',
          opacity: 0.1,
          animation: 'gridPulse 6s ease-in-out infinite'
        }}></div>
      </div>

      <div className="relative max-w-6xl mx-auto">
        {/* Cyberpunk Header Section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-black/60 border-2 border-cyan-400 rounded-2xl mb-8 shadow-neon-cyan group hover:scale-110 transition-transform duration-300">
            <svg className="w-10 h-10 text-cyan-400 group-hover:text-pink-400 transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <div className="absolute inset-0 border-2 border-cyan-400/50 rounded-2xl animate-border-pulse"></div>
          </div>
          
          <h2 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-500 to-green-400 mb-6 font-mono tracking-wider animate-gradient-x">
            [KNOWLEDGE_MATRIX]
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed font-mono">
            <span className="text-cyan-400">{'>'}</span> Tổng hợp kiến thức từ các khóa học uy tín<br/>
            <span className="text-pink-400">{'>'}</span> Được trình bày lại thông qua 
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400 font-bold"> DỰ ÁN THỰC HÀNH </span><br/>
            <span className="text-green-400">{'>'}</span> Để giúp mọi người dễ dàng tiếp cận và học hỏi
            <span className="animate-blink text-cyan-400">█</span>
          </p>
        </div>

        {/* Cyberpunk Companies Showcase */}
        <div className="relative bg-black/60 backdrop-blur-sm rounded-3xl p-8 border border-cyan-400/30 mb-12 shadow-neon-cyan overflow-hidden">
          {/* Holographic background */}
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/5 via-pink-500/5 to-green-500/5 rounded-3xl"></div>
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent animate-slide-right rounded-t-3xl"></div>
          
          {/* Matrix-style label */}
          <div className="text-center mb-6">
            <span className="text-cyan-400 font-mono text-lg tracking-wider">TRUSTED PLATFORMS DATABASE</span>
          </div>

          {/* Animated Company Logos */}
          <div
            className="group relative overflow-hidden w-full rounded-2xl"
            style={{
              maskImage: 'linear-gradient(to right, transparent 0%, rgb(0, 0, 0) 15%, rgb(0, 0, 0) 85%, transparent 100%)',
              WebkitMaskImage: 'linear-gradient(to right, transparent 0%, rgb(0, 0, 0) 15%, rgb(0, 0, 0) 85%, transparent 100%)'
            }}
          >
            <div className="flex animate-marquee-left group-hover:[animation-play-state:paused] whitespace-nowrap py-6">
              {/* First set of logos */}
              <div className="flex items-center gap-12 mx-8 shrink-0">
                {companies.map((company, index) => (
                  <div 
                    key={index}
                    className="group/logo relative p-6 rounded-2xl bg-black/40 backdrop-blur-sm border border-cyan-400/30 hover:border-pink-400/50 transition-all duration-300 hover:scale-110 shadow-neon-cyan hover:shadow-neon-pink"
                  >
                    <img 
                      className="transition-all duration-300 group-hover/logo:brightness-125 filter group-hover/logo:drop-shadow-lg" 
                      style={{ 
                        height: company.height, 
                        width: "auto",
                        filter: 'brightness(0.9) contrast(1.1)'
                      }}
                      src={company.logo} 
                      alt={company.name}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-cyan-400/10 via-pink-400/5 to-transparent opacity-0 group-hover/logo:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                    <div className="absolute -inset-1 border border-pink-400/20 rounded-2xl opacity-0 group-hover/logo:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
                  </div>
                ))}
              </div>
              
              {/* Duplicate set for seamless loop */}
              <div className="flex items-center gap-12 mx-8 shrink-0">
                {companies.map((company, index) => (
                  <div 
                    key={`duplicate-${index}`}
                    className="group/logo relative p-6 rounded-2xl bg-black/40 backdrop-blur-sm border border-cyan-400/30 hover:border-pink-400/50 transition-all duration-300 hover:scale-110 shadow-neon-cyan hover:shadow-neon-pink"
                  >
                    <img 
                      className="transition-all duration-300 group-hover/logo:brightness-125 filter group-hover/logo:drop-shadow-lg" 
                      style={{ 
                        height: company.height, 
                        width: "auto",
                        filter: 'brightness(0.9) contrast(1.1)'
                      }}
                      src={company.logo} 
                      alt={company.name}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-cyan-400/10 via-pink-400/5 to-transparent opacity-0 group-hover/logo:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                    <div className="absolute -inset-1 border border-pink-400/20 rounded-2xl opacity-0 group-hover/logo:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Cyberpunk pause indicator */}
          <div className="text-center mt-6">
            <p className="text-sm text-cyan-400/70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 font-mono">
              HOVER TO PAUSE MATRIX SCAN
            </p>
          </div>
        </div>

        {/* Cyberpunk Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {/* Quality Card */}
          <div className="group relative bg-black/60 backdrop-blur-sm rounded-2xl p-8 border border-cyan-400/50 shadow-neon-cyan hover:shadow-neon-cyan-intense transform hover:-translate-y-4 hover:rotate-1 transition-all duration-500 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-600/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent animate-slide-right rounded-t-2xl"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 bg-black border-2 border-cyan-400 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-12 transition-transform duration-300 shadow-neon-cyan">
                <svg className="w-8 h-8 text-cyan-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-cyan-400 mb-4 font-mono tracking-wider">
                PREMIUM QUALITY
              </h3>
              <p className="text-gray-300 leading-relaxed font-mono text-sm">
                {'>'} Nội dung được tuyển chọn từ các nền tảng<br/>
                {'>'} Học tập uy tín hàng đầu thế giới
              </p>
            </div>
          </div>

          {/* Practice Card */}
          <div className="group relative bg-black/60 backdrop-blur-sm rounded-2xl p-8 border border-green-400/50 shadow-neon-green hover:shadow-neon-green-intense transform hover:-translate-y-4 hover:-rotate-1 transition-all duration-500 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-green-500/10 to-emerald-600/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-400 to-transparent animate-slide-right delay-500 rounded-t-2xl"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 bg-black border-2 border-green-400 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:-rotate-12 transition-transform duration-300 shadow-neon-green">
                <svg className="w-8 h-8 text-green-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-green-400 mb-4 font-mono tracking-wider">
                HANDS ON PRACTICE
              </h3>
              <p className="text-gray-300 leading-relaxed font-mono text-sm">
                {'>'} Học thông qua các dự án thực tế<br/>
                {'>'} Bài tập ứng dụng thực tiễn
              </p>
            </div>
          </div>

          {/* Updates Card */}
          <div className="group relative bg-black/60 backdrop-blur-sm rounded-2xl p-8 border border-pink-500/50 shadow-neon-pink hover:shadow-neon-pink-intense transform hover:-translate-y-4 hover:rotate-1 transition-all duration-500 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/10 to-purple-600/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-pink-500 to-transparent animate-slide-right delay-1000 rounded-t-2xl"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 bg-black border-2 border-pink-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-12 transition-transform duration-300 shadow-neon-pink">
                <svg className="w-8 h-8 text-pink-500" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-pink-500 mb-4 font-mono tracking-wider">
                REAL TIME UPDATES
              </h3>
              <p className="text-gray-300 leading-relaxed font-mono text-sm">
                {'>'} Nội dung được cập nhật liên tục<br/>
                {'>'} Theo xu hướng công nghệ mới nhất
              </p>
            </div>
          </div>
        </div>

        {/* Cyberpunk CTA Button */}
      </div>

      <style jsx>{`
        @keyframes marquee-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        @keyframes pulse-neon {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.1); }
        }

        @keyframes gridPulse {
          0%, 100% { opacity: 0.05; }
          50% { opacity: 0.15; }
        }

        @keyframes gradient-x {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }

        @keyframes border-pulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }

        @keyframes slide-right {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }

        @keyframes border-rainbow {
          0% { border-image: linear-gradient(45deg, cyan, transparent, transparent, cyan) 1; }
          25% { border-image: linear-gradient(45deg, transparent, pink, transparent, transparent) 1; }
          50% { border-image: linear-gradient(45deg, transparent, transparent, green, transparent) 1; }
          75% { border-image: linear-gradient(45deg, transparent, transparent, transparent, purple) 1; }
          100% { border-image: linear-gradient(45deg, cyan, transparent, transparent, cyan) 1; }
        }

        .animate-marquee-left {
          animation: marquee-left 30s linear infinite;
          will-change: transform;
        }

        .animate-pulse-neon { animation: pulse-neon 4s ease-in-out infinite; }
        .animate-gradient-x { 
          background-size: 400% 400%;
          animation: gradient-x 3s ease infinite;
        }
        .animate-blink { animation: blink 1s step-start infinite; }
        .animate-border-pulse { animation: border-pulse 2s ease-in-out infinite; }
        .animate-slide-right { animation: slide-right 3s ease-in-out infinite; }
        .animate-border-rainbow { animation: border-rainbow 4s linear infinite; }

        .shadow-neon-cyan { box-shadow: 0 0 20px rgba(0,255,255,0.5), 0 0 40px rgba(0,255,255,0.3), 0 0 60px rgba(0,255,255,0.1); }
        .shadow-neon-cyan-intense { box-shadow: 0 0 30px rgba(0,255,255,0.7), 0 0 60px rgba(0,255,255,0.5), 0 0 90px rgba(0,255,255,0.3); }
        .shadow-neon-pink { box-shadow: 0 0 20px rgba(255,0,128,0.5), 0 0 40px rgba(255,0,128,0.3), 0 0 60px rgba(255,0,128,0.1); }
        .shadow-neon-pink-intense { box-shadow: 0 0 30px rgba(255,0,128,0.7), 0 0 60px rgba(255,0,128,0.5), 0 0 90px rgba(255,0,128,0.3); }
        .shadow-neon-green { box-shadow: 0 0 20px rgba(0,255,128,0.5), 0 0 40px rgba(0,255,128,0.3), 0 0 60px rgba(0,255,128,0.1); }
        .shadow-neon-green-intense { box-shadow: 0 0 30px rgba(0,255,128,0.7), 0 0 60px rgba(0,255,128,0.5), 0 0 90px rgba(0,255,128,0.3); }
        .shadow-neon-multi { box-shadow: 0 0 20px rgba(0,255,255,0.4), 0 0 40px rgba(255,0,128,0.4), 0 0 60px rgba(0,255,128,0.4); }
        .shadow-neon-multi-intense { box-shadow: 0 0 40px rgba(0,255,255,0.6), 0 0 80px rgba(255,0,128,0.6), 0 0 120px rgba(0,255,128,0.6); }

        .delay-500 { animation-delay: 0.5s; }
        .delay-1000 { animation-delay: 1s; }
      `}</style>
    </div>
  );
}
